<template>
	<footer :class="['footer', { 'dark-mode': isDarkMode }]">
		<div class="container">
			<i class="fa-regular fa-copyright"></i> 2024 Tenny Enterprises Inc. All rights reserved.
		</div>
	</footer>
</template>

<script src="./FooterScript.vue"/>